export const lastUpdateTimeService = {
    updateEventObservers: new Set(),
    registerUpdateEventObserver(observer: Function) {
        this.updateEventObservers.add(observer);
    },

    unRegisterUpdateEventObserver(observer: Function) {
        try {
            this.updateEventObservers.delete(observer);
        } catch(err) {
            console.log(err);
        }
    },

    notifyUpdateEvent() {
        try {
            this.updateEventObservers.forEach((observer: Function) => observer());
        } catch(err) {
            console.log(err);
        }
    },

    cleanObservers() {
        this.updateEventObservers.clear();
    },
};
